export const REWARDS_NAME = 'reward';
export const REWARDS_NAME_PLURAL = 'rewards';
export const REWARDS_TRACKING_NAME = 'sticker';
export const REWARDS_TRACKING_NAME_PLURAL = 'stickers';

export const REWARD_TYPE = {
  percent: { label: '%', value: 'percent' },
  dollarAmount: { label: '$', value: 'dollar_amount' },
};

export const REWARDS_REPORT_TYPES = {
  enrolledDiners: 'loyalty_diners.enrolled_diners',
  aov: 'loyalty_daily_metrics.aov',
  rewardsOutstanding: 'loyalty.rewards_outstanding',
  rewardsRedeemed: 'loyalty_daily_metrics.rewards_redeemed',
  rewardsUnlocked: 'loyalty_daily_metrics.rewards_unlocked',
  stickersCollected: 'loyalty_daily_metrics.order_count',
  grossOrderTotal: 'loyalty_daily_metrics.gross_order_total_local',
};

export const REWARDS_REPORT_FILTERS = {
  dailyMetricsRestaurantId: 'loyalty_daily_metrics.restaurant_id',
  loyaltyDinersRestaurantId: 'loyalty_diners.restaurant_id',
};

export const REWARDS_TIME_DIMENSIONS = {
  calendarDateLocal: 'loyalty_daily_metrics.calendar_date_local',
  enrolledDateLocal: 'loyalty_diners.enrolled_date_local',
};

export const REWARDS_CUBE_ROW_LIMIT = 1000;
